export function formatAddress (address) {
  return address.addressLines[0] +
      (!!address.addressLines[1]
          ? (address.addressLines[1] + " ")
          : "") +
      ", " + address.locality +
      ", " + address.administrativeArea +
      " " + address.postalCode
}

export const verificationMethodNames = {
  "PHONE_CALL": "The business was called.",
  "SMS": "An sms was sent to the business.",
  "EMAIL": "An email was sent to the business.",
  "ADDRESS": "A postcard was mailed to the business."
};

export const phoneCallVerificationMethod = (availableVerificationMethods) => !!availableVerificationMethods && availableVerificationMethods.find(verificationMethod => verificationMethod.verificationMethod === "PHONE_CALL");
export const smsVerificationMethod = (availableVerificationMethods) => !!availableVerificationMethods && availableVerificationMethods.find(verificationMethod => verificationMethod.verificationMethod === "SMS");
export const emailVerificationMethod = (availableVerificationMethods) => !!availableVerificationMethods && availableVerificationMethods.find(verificationMethod => verificationMethod.verificationMethod === "EMAIL");
export const addressVerificationMethod = (availableVerificationMethods) => !!availableVerificationMethods && availableVerificationMethods.find(verificationMethod => verificationMethod.verificationMethod === "ADDRESS");